export const fallbackImageUrl = '/assets/images/png/fallback-product-image.png';
export const blurDataUrl =
    'data:image/svg+xml;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mM0sjLaBAAClgFSRhRBswAAAABJRU5ErkJggg==';

export const ogImage = process.env.NEXT_PUBLIC_URL + '/assets/images/jpg/goed-og.jpg';
export const ogImageDefaultWidth = 1200;
export const ogImageDefaultHeight = 630;
